import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
	providedIn: 'root',
})
export class ExportService {

	constructor(
		protected readonly toastr: ToastrService,
	) {
	}

	public downloadExportedData(
		data: HttpResponse<Blob>,
		exportFileName: string,
	) {
		const newBlob = new Blob([data.body], { type: 'application/octet-stream' });
		const downloadURL = window.URL.createObjectURL(newBlob);

		const link = document.createElement('a');
		link.href = downloadURL;
		link.download = exportFileName;
		this.toastr.success(`Data Exported successfully: ${link.download}`);
		link.click();
	}
}
